import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import { Article } from "@/lib/types/Article";
import PageHead from "@/src/shared/PageHead";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import Header from "@/src/shared/Header/Header";
import BackToTop from "@/src/shared/BackToTop";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import ArticleDetail from "@/src/features/articles/detail/ArticleDetail";
import ArticleDetailContext, { IArticleDetailContext } from "@/src/features/articles/detail/ArticleDetailContext";
import API from "@/lib/api";

export default function Detail({ page }: { page: IArticleDetailContext }) {
  return (
    <ArticleDetailContext.Provider value={page} key={page.article.IdGuid}>
      <PageHead title={page.article.MetaTitle} description={page.article.MetaDescription} ignoreTitleSuffix />
      <MobileMenu />
      <Header />
      <ArticleDetail />
      <BackToTop />
      <Separator />
      <Footer />
    </ArticleDetailContext.Provider>
  );
}

export const getServerSideProps = sharedServerSideProps(async context => {
  const { slug } = context.params;

  const article = await API.Client.get<Article>("/api/article", { params: { Search: slug } });
  console.log(article);
  const documents = article?.IdGuid
    ? await API.Client.get<Document[]>("/api/document/list", {
        params: {
          Skip: 0,
          Take: 3,
          Search: article.IdGuid
        }
      })
    : [];

  return {
    page: { article, documents }
  };
});
